module.exports = __webpack_public_path__ + "static/Intro3dDemo-8816523f43f74ea9b643a97c1788d64a.ogv";